{
  "version": 1,
  "asset_id": "0b0c017e-03c6-449b-8666-597e409048a6",
  "project_id": "4e628cc3-9baa-4a87-b23b-02ac04e85c33",
  "url": "/__l5e/assets-v1/0b0c017e-03c6-449b-8666-597e409048a6/resultado_2.png",
  "r2_key": "a/v1/4e628cc3-9baa-4a87-b23b-02ac04e85c33/0b0c017e-03c6-449b-8666-597e409048a6/resultado_2.png",
  "original_filename": "resultado_2.png",
  "size": 964287,
  "content_type": "image/png",
  "created_at": "2026-07-07T11:53:06Z"
}
